import { styled } from "styled-components"
import { AlignBox, BackBtn, EmtpyBox } from "../atom"
import { useState, HTMLAttributes, useRef, useEffect } from 'react'
import { useLocation, useNavigate } from "react-router-dom"
import { useTimer } from '../utill/useTimer';
import { TimeoutPopUp } from "../component/PopUp";
import { joinRoom, leaveRoom, sendMsg, socketListener } from "../apis/socket";
import { trackEvent } from "../apis/amplitude";


const Chatting = () => {

    const [myText, setMyText] = useState('')
    const [isPopup, setIsPopup] = useState(true);
    const [socketMsg, setSocketMsg] = useState({id: '0', msg: "입력이 실시간으로 보입니다. 엔터로 전체 전부 삭제 "});

    const nav = useNavigate();

    const {minutes, seconds, isFinished} = useTimer(4)

    const roomId = useLocation().state.roomNum;
    const id = useLocation().state.id;

    
    useEffect(() => {
        joinRoom(roomId);
        trackEvent('채팅 입장', {id: id, roomNum: roomId});

        socketListener({
            setSocketMsg: setSocketMsg,
            myId: id
        });
    }, [])

    useEffect(() => {

        sendMsg({
            roomId: roomId,
            msg: myText,
            id: id
        })

        trackEvent('메세지 전송', {id: id, roomNum: roomId, msg: myText})
    }, [myText])

    useEffect(() => {

        socketMsg.msg === '상대가 방을 나갔습니다.' && setIsPopup(true)

    }, [socketMsg])

    useEffect(()=> {
        if(isFinished && isPopup){
            trackEvent('시간 종료 퇴장', {id: id, roomNum: roomId});
            leaveRoom(roomId);
        }
    }, [isFinished])


    return ( 
        <AlignBox justify="center" align="center">
            {
                (isFinished && isPopup) && 
                <TimeoutPopUp
                    xHandler={(e:any)=>{
                        e.preventDefault();
                        setIsPopup(false);
                    }}
                />
            }
            
            <Header>
                <BackBtn onClick={() => {
                    if(!window.confirm("채팅을 종료하시겠습니까?")) return null;

                    setMyText('상대가 방을 나갔습니다.');

                    trackEvent('상대가 퇴장', {id: id, roomNum: roomId});

                    leaveRoom(roomId);

                    nav('/question', {state: {id: id}});
                }}/>
                {minutes+ ":" + seconds}
            </Header>
            <Balloon me = {false} text = {socketMsg.msg} />
            <EmtpyBox height={1}/>
            <Balloon me={true}  setMyText = {setMyText} text={myText} onChange={(e)=>{setMyText(e.target.value)}}/>
        </AlignBox >
    )
}

function Balloon({ me, text, onChange, setMyText }: 
    { 
        me: boolean 
        text: string
        setMyText?: (text: string) => void
        onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
    }) {
    
    const textLength = text.length;


    let fontSize = '50px';
    const textMiddle = textLength <= 6


    if (textLength <= 6) {
        fontSize = '51px';
    } else if (textLength <= 10) {
        fontSize = '50px';
    } else if (textLength <= 14) {
        fontSize = '40px';
    } else if (textLength <= 20) {
        fontSize = '30px';
    } else if (textLength <= 33) {
        fontSize = '26px';
    } else if (textLength <= 45) {
        fontSize = '20px';
    } else if (textLength <= 95){
        fontSize = '16px';
    } else {
        alert("지금이 최대 글자수에요 🧐")
        text = text.slice(0, 95);
        fontSize = '16px';
    }

    const BallonColor = me ? "#4F8FFB" : "#F3F1F8";

    return (
        <BalloonContainer BallonColor={BallonColor}>
            <BalloonTail BallonColor={BallonColor} top={!me}/>
            {
                me ? 
                <AutoSizeTextarea 
                    setMyText = {setMyText}
                    me = {me}
                    textMiddle = {textMiddle}
                    value = {text}
                    fontSize = {fontSize}
                    onChange = {onChange}
                />
                : <AutoSizeTextarea
                    textMiddle = {textMiddle}
                    value = {text}
                    fontSize = {fontSize}
                    readOnly
                />
            }
      </BalloonContainer>
    );
  }

interface BallonColorProp {
    BallonColor: string;
}

// 말풍선 스타일드 컴포넌트 생성
const BalloonContainer = styled.div<BallonColorProp>`
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    width: 315px;
    height: 140px;
    padding: 25px;
    background-color: ${({ BallonColor }) => BallonColor};
    border-radius: 30px;
`;

interface BalloonTailProp {
    top: boolean;
    BallonColor: string;
}

const BalloonTail = styled.div<BalloonTailProp>`

  z-index: -1;
  position: absolute;
  left: 50%;
  bottom: -10px;
  /* 180도 회전 시키기 */
  top: ${({top})=> top ? "-10px" : "none"};
  transform: ${({top})=> top ? "rotate(180deg)" : "none"};
  width: 0;
  height: 0;
  margin-left: -15px; /* 꽁다리 가로 길이 조정 */
  border-left: 15px solid transparent; /* 꽁다리 가로 길이 조정 */
  border-right: 15px solid transparent; /* 꽁다리 가로 길이 조정 */
  border-top: 20px solid ${({BallonColor})=> BallonColor};
  border-bottom-left-radius: 15px; /* 왼쪽 하단 라운드 반경 설정 */
  border-bottom-right-radius: 15px; /* 오른쪽 하단 라운드 반경 설정 */
`;


interface BalloonInputProp extends HTMLAttributes<HTMLTextAreaElement> {
    fontSize: string;
    textMiddle: boolean;
    me: boolean;
}

const BalloonInput = styled.textarea<BalloonInputProp>`

  position: absolute;

  top:  ${({textMiddle})=> textMiddle ? "13px" : "none"};


  font-size: ${({fontSize})=> fontSize};
  color: ${({ me }) => me ? "#fff" : "#000"};
  width: 100%;
  border: none;
  background-color: transparent;
  outline: none;
  resize: none;
  text-align: center;
  padding: 25px;
  
  white-space: pre-wrap;
  overflow: hidden;

  &:focus {
    outline: none;
  }
`;

function AutoSizeTextarea(props: any) {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);


    // 컴포넌트가 처음 렌더링될 때 textarea에 포커스 설정
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
            // 0.03초 후에 실행

            setTimeout(() => {
                window.scrollTo({
                    top: 0, // 페이지의 맨 위로 이동
                    behavior: 'auto', // 즉시 스크롤
                });
            }, 200);
        }
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0, // 페이지의 맨 위로 이동
            behavior: 'auto', // 즉시 스크롤
        });
    });


    useEffect(() => {
        window.scrollTo({
            top: 0, // 페이지의 맨 위로 이동
            behavior: 'auto', // 즉시 스크롤
        });
    }, [textareaRef.current])


    const handleKeyDown = (e:any) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            props.setMyText('')
        }
      };

    useEffect(() => {
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto'; // 초기 높이 설정
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // 스크롤 없는 높이로 설정
      }
    }, [props.value]);
  
    return <BalloonInput me={props.me} onKeyDown={handleKeyDown} ref={textareaRef} {...props} />;
  }
  

const Header = styled.header`

    font-size: 24px;
    font-weight: 700;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100vw;
    height: 60px;
    background-color: #fff;
`

export default Chatting